import { createTRPCClient, httpBatchLink } from '@trpc/client';
import type { AppRouter } from '@aos/api';
import { getAccessToken } from './auth.js';

export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: '/api/trpc',
      headers() {
        const token = getAccessToken();
        return token ? { Authorization: `Bearer ${token}` } : {};
      },
    }),
  ],
});
